<template>
  <v-container>
    <section id="Home" @mousemove="memphis($event)">
      <img src="@/assets/memphis-01.png" data-speed="5" class="memphis" />
      <img src="@/assets/memphis-02.png" data-speed="2" class="memphis" />
      <img src="@/assets/memphis-03.png" data-speed="6" class="memphis" />
      <div class="d-flex flex-column text-center align-center introduce">
        <img src="@/assets/girld.png" width="170" />
        <h1>Aunyamanee Srilerd</h1>
        <p>I'm a <span class="frontend">Front-End Developer</span></p>
        <v-row>
          <div class="d-flex flex-row justif-space-between socialIcon">
            <img src="@/assets/github.png" class="ic" />
            <img src="@/assets/instagram.png" class="ic" />
            <img src="@/assets/facebook-circular-logo.png" class="ic" />
          </div>
        </v-row>
        <br />
        <button>Hire me!</button>
      </div>
      <!-- <v-spacer></v-spacer> -->
      <p class="scrolldown"><img src="@/assets/mouse.png" /></p>
    </section>
    <section id="About"><About /></section>
    <section id="Service"><Service /></section>
    <section id="Experience"><Experience /></section>
    <section id="Works"><Work /></section>
    <section id="Contact"><Contact /></section>
  </v-container>
</template>

<script>
import About from "../components/about";
import Contact from "../components/contact";
import Experience from "../components/experience";
import Service from "../components/service";
import Work from "../components/work";
export default {
  name: "HelloWorld",
  components: {
    About,
    Contact,
    Experience,
    Service,
    Work,
  },
  methods: {
    memphis(event) {
      document.querySelectorAll(".memphis").forEach((Memphis) => {
        const speed = Memphis.getAttribute("data-speed");
        const x = (window.innerWidth - event.pageX * speed) / 100;
        const y = (window.innerHeight - event.pageY * speed) / 100;
        // console.log(x, y);

        Memphis.style.transform = `translateX(${x}px)  translateY(${y}px)`;
      });
    },
  },
};
</script>
<style scoped>
#Home {
  display: flex;
  flex-direction: column;
}
.introduce {
  z-index: 10;
}
.introduce .ic {
  width: 25px;
  margin: 10px 20px 20px 20px;
}
.introduce h1 {
  color: #48445e;
  margin: 10px 0 10px 0;
  font-size: 35px;
}
.introduce p {
  margin: 0px 0 30px 0;
}
.introduce button {
  color: white;
  background: #ff3555;
  padding: 10px;
  width: 120px;
  border-radius: 25px;
  outline: none;
}
.introduce button:hover {
  color: #ff3555;
  background: #faf8ff;
  border: 1px solid #ff3555;
}
.introduce button:active {
  transform: scale(0.9);
}
@keyframes down {
  0%,
  100% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(5px);
  }
}
.scrolldown {
  position: absolute;
  margin-top: 40%;
  animation: down 1s infinite;
}
section {
  /* height: 100vh; */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3em;
}
#Work,
#Experience {
  height: auto;
}
#Home {
  height: 100vh;
}
#About,
#Service {
  /* height: 60vh; */
}
#Contact {
  height: 100vh;
}
.socialIcon {
  padding-bottom: 50;
}
.socialIcon img {
  margin: 5px;
}
.memphis {
  position: absolute;
  width: 1120px;
  z-index: 0;
}
@keyframes spanScale {
  0%,
  100% {
    font-size: 20.5px;
  }
  50% {
    font-size: 20px;
  }
}
.frontend {
  /* animation: spanScale 0.9s infinite ; */
}
@media screen and (max-width: 700px) {
  .scrolldown {
    display: none;
  }
  #Home {
    overflow: hidden;
  }
  .memphis {
    position: absolute;
    width: 800px;
    z-index: 0;
    overflow: hidden;
    /* display: none */
  }
  .introduce {
  z-index:0;
}
}
@media screen and (max-width: 800px) {
  .scrolldown {
    display: none;
  }
  .memphis {
    position: absolute;
    width: 750px;
    z-index: 0;
    overflow: hidden;
    /* display: none */
  }
 
}
</style>
